import { render, staticRenderFns } from "./UpdatePropertyStatusFieldField.vue?vue&type=template&id=a002b4bc&"
import script from "./UpdatePropertyStatusFieldField.vue?vue&type=script&lang=js&"
export * from "./UpdatePropertyStatusFieldField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports